export const projectInquiry = {
  projectType: "Project Type",
  projectValue: "Project Value",
  estimatedValue: "Estimated Value",
  currentValue: "Current value: {{value}}",
  buttons: {
    createInquiry: "Create Inquiry",
  }
}
